module.exports = "/img/facobook_logo.png?015efa5ee0b2dbbc23ff73895eb94007";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/facobook_logo.png
// module id = uPOe
// module chunks = 46